import { StringSchema } from 'yup';
import moment from 'moment';

export default function (this: StringSchema, minDate: string, message: string) {
  return this.test('minDate', message, (value) => {
    const dateFormat = 'DD/MM/YYYY';

    return moment(value, dateFormat).isAfter(moment(minDate, dateFormat));
  });
}
